import { Box, Fade, List, ListItem } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";
import MenuContext from "../store/menu-context";
import classes from "../Style/Menu.scss";

const Menu = (props) => {
    const ctx = useContext(MenuContext);
    const handleSecondaryMenuClick = (index, id) => {
        ctx.updateContext(index, false);
    }


    return (
        <Box className="menuWrapper">
            {/* <Link to={PageRoutes.ROOT}>Home</Link> */}
            <Link to={PageRoutes.CHAPTER_ONE}>
                <Box sx={{ display: 'flex' }}>
                    <Box className={props.path === PageRoutes.CHAPTER_ONE || props.path.indexOf('commodity') > -1 ? "active" : "activePlaceholder"}></Box>
                    <Box className="menuItem">
                        <span>CHAPTER ONE</span>
                        <h3>EU-Coordinated Multiannual Control Programme</h3>
                    </Box>
                </Box>

            </Link>
            <Link to={PageRoutes.CHAPTER_TWO}>
                <Box sx={{ display: 'flex' }}>
                    <Box className={props.path === PageRoutes.CHAPTER_TWO ? "active" : "activePlaceholder"}></Box>
                    <Box className="menuItem">
                        <span>CHAPTER TWO</span>
                        <h3>Multiannual Control National Programme</h3>
                    </Box>
                </Box>
            </Link>
            <Fade in={props.path === PageRoutes.CHAPTER_TWO}>
                <List className="secondaryMenu">
                    <ListItem>
                        <Box sx={{ display: 'flex' }}>
                            <Box className="secondaryActiveWrapper">
                                <Box className={ctx.index === 0 ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive' : 'secondaryActiveWrapperInner'}></Box>
                            </Box>
                            <Link onClick={handleSecondaryMenuClick.bind(this, 0)} to='#'>Section I: Geospatial</Link>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box sx={{ display: 'flex' }}>
                            <Box className="secondaryActiveWrapper">
                                <Box className={ctx.index === 1 ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive' : 'secondaryActiveWrapperInner'}></Box>
                            </Box>
                            <Link onClick={handleSecondaryMenuClick.bind(this, 1)} to='#'>Section II: Residue level</Link>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box sx={{ display: 'flex' }}>
                            <Box className="secondaryActiveWrapper">
                                <Box className={ctx.index === 2 ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive' : 'secondaryActiveWrapperInner'}></Box>
                            </Box>
                            <Link onClick={handleSecondaryMenuClick.bind(this, 2)} to='#'>Section III: Product groups</Link>
                        </Box>
                    </ListItem>
                </List>
            </Fade>

        </Box>
    );
}

export default Menu;